export const resetGlobalVariables = () => {
  delete window.__mobxGlobals
}
